import { render, staticRenderFns } from "./Legends.vue?vue&type=template&id=046d03fc&scoped=true"
import script from "./Legends.vue?vue&type=script&lang=js"
export * from "./Legends.vue?vue&type=script&lang=js"
import style0 from "./Legends.vue?vue&type=style&index=0&id=046d03fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046d03fc",
  null
  
)

export default component.exports